<!--
 * @Description: 登录
 * @Author: 山淑兰
 * @Date: 2019-10-11 15:44:40
 * @LastEditTime: 2020-07-10 09:33:41
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="page">
		<iframe :src="expertUrl" width="100%" height="100%" border="0" frameborder="no"></iframe>
	</div>
</template>
<script>
	import {
		IMeetingInfo,
		current
	} from "@/contants/current";
	export default {
		name: 'initPage',
		data() {
			return {
				m: '',
				expertUrl: '',
			}
		},

		created() {
			const {
				m
			} = this.$route.query;
			this.m = String(m);
			this.InitMeetingInfo();
			this.current = new current();
			let _isMobile = this.current.is_Mobile();
			console.log(_isMobile)
			if (_isMobile) {
				let _params = window.location.href.split("?")[1];
				window.location.href = `https://mp.weiqihd.com/mpweb/#/initPage?${_params}`;
			}
			this.checkLoginStatus()
		},
		mounted() {
			
		},
		methods: {
			/**
			 * @description: 获取会议基本信息
			 */
			async InitMeetingInfo() {
				let params = {
					m: this.m,
				};
				let res = await IMeetingInfo.InitMeetingInfo(params);
				this.bannerSrc = res.PCBannerImage;
				this.meetingTitle = res.MeetingTitle;
				console.log("会议基本信息", res);
			},
			async checkLoginStatus() {
				let _params = {
					m: this.m,
				}
				let _Res = await this.$http.expert.CheckExpert(_params)
				if (_Res.Code === 1000) {
					this.init()
				} else {
					this.$router.push({
						path: "/elogin",
						query: this.$route.query,
					});
				}
			},
			async init() {
				let _params = {
					m: this.m,
				}
				let Res = await this.$http.expert.InitExpertPage(_params)
				if (Res.Code === 1000) {
					this.expertUrl = Res.ExpertUrl
				}else {
					this.$notify({
						message: Res.Msg,
						type: 'danger',
					})
				}
			},
		},
	}
</script>
<style scoped lang="scss">
	#page {
		width: 100%;
		height: 100vh;
	}
</style>
<style type="text/css">
	body,
	#app {
		background: #0f172a;
	}
	.has{
		height: calc(100% - 45px);
	}
	.no{
		height: 100%;
	}
</style>
